import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Card, CardBody, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import INBDETable from '../table/INBDETable';
import FalconCardHeader from '../common/FalconCardHeader';
import { columns } from '../../data/randomSets/pastRandomSetsTable';
import { isIterableArray } from '../../helpers/utils';
import { searchPath } from '../../routes';

// every part of a row an admin might reasonably type into the box, including the
// filters, which is where most rows differ from one another
const searchableText = randomSet => {
  const filters = isIterableArray(randomSet.filters)
    ? randomSet.filters.map(group => group.label + ' ' + group.values.join(' ')).join(' ')
    : '';

  return [
    randomSet.name,
    randomSet.created_by && randomSet.created_by.displayName,
    randomSet.format,
    randomSet.keywords,
    filters
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
};

const EmptyRandomSets = () => (
  <CardBody className="text-center text-600 py-6">
    <FontAwesomeIcon icon="random" className="fs-4 text-300 d-block mx-auto mb-3" />
    No random sets have been exported yet.
    <div className="fs--1 mt-2">
      Draw a set on <Link to={searchPath}>Search Content</Link> and export it, and it will be listed here.
    </div>
  </CardBody>
);

const PastRandomSetsTable = ({ isLoading, randomSets }) => {
  const [search, setSearch] = useState('');

  const term = search.trim().toLowerCase();
  const rows = term ? randomSets.filter(randomSet => searchableText(randomSet).includes(term)) : randomSets;
  const isEmpty = !isLoading && !isIterableArray(randomSets);

  return (
    <Card className="mb-3 mt-3">
      <FalconCardHeader title="Exported Random Sets" light={false}>
        {!isEmpty && (
          <Input
            aria-label="Search exported random sets"
            bsSize="sm"
            onChange={event => setSearch(event.target.value)}
            placeholder="Search these sets"
            style={{ width: '15rem', maxWidth: '100%' }}
            type="search"
            value={search}
          />
        )}
      </FalconCardHeader>
      {isEmpty ? (
        <EmptyRandomSets />
      ) : (
        <CardBody>
          <INBDETable data={rows} columns={columns} />
        </CardBody>
      )}
    </Card>
  );
};

PastRandomSetsTable.propTypes = {
  isLoading: PropTypes.bool,
  randomSets: PropTypes.array
};

PastRandomSetsTable.defaultProps = {
  isLoading: false,
  randomSets: []
};

export default PastRandomSetsTable;
